// WhatsAppOrderForm.js
import React, { useState, useEffect } from 'react';
import './WhatsAppOrderForm.css';
import { motion } from "framer-motion";

function WhatsAppOrderForm({ onSubmit, onClose  }) {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobileNumber: '',
        whatsappNumber: '',
        productQuantity: 1,
        province:'',
        city:'',
        address: ''
    });

    const [errors, setErrors] = useState({});

     // Disable body scroll when the form is open
     useEffect(() => {
        document.body.style.overflow = 'hidden'; // Disable scrolling
        return () => {
            document.body.style.overflow = 'auto'; // Re-enable scrolling when the form is closed
        };
    }, []);

     // Handle clicks outside the form to close it
     const handleBackdropClick = (e) => {
        if (e.target.classList.contains('modal-backdrop')) {
            onClose();
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "productQuantity") {
            const re = /^[1-9]\d*$/;  
            if (value === '' || re.test(value)) {
                setFormData({ ...formData, [name]: value });
            }
        } else if (name === "mobileNumber" || name === "whatsappNumber") {
            // Allow only numeric input
            const numericValue = value.replace(/\D/g, '');
            setFormData({ ...formData, [name]: numericValue });
        } else {
            setFormData({ ...formData, [name]: value });
        }
        if (errors[name]) {
            setErrors({ ...errors, [name]: null });
        }
    };

    
    const handleSubmit = (e) => {
        e.preventDefault();
        const newErrors = {};

        // Validate email (if provided)
        if (formData.email && !/^[a-zA-Z0-9._%+-]+@gmail\.com$/.test(formData.email)) {
            newErrors.email = "Invalid email format. Please enter a valid Email address (e.g., example@gmail.com).";
        }

        // Validate mobile number
        if (!/^(03\d{9}|923\d{9})$/.test(formData.mobileNumber)) {
            newErrors.mobileNumber = "Invalid mobile number format.";
        }

        // Validate WhatsApp number
        if (!/^(03\d{9}|923\d{9})$/.test(formData.whatsappNumber)) {
            newErrors.whatsappNumber = "Invalid WhatsApp number format.";
        }


        // If there are errors, set them and stop submission
        if (Object.keys(newErrors).length > 0) {
            let errorMessage = "";
            for (const key in newErrors) {
              errorMessage += `${newErrors[key]}\n`;
            }
            alert(errorMessage); // Show all errors in an alert box
        } else {
            onSubmit(formData);
            onClose();
        }
    };

    // const handleSubmit = (e) => {
    //     e.preventDefault();

    //     // Validate email (if provided)
    //     if (formData.email && !/^[a-zA-Z0-9._%+-]+@gmail\.com$/.test(formData.email)) {
    //         alert("Invalid email format. Please enter a valid Email address (e.g., example@gmail.com).");
    //         return; // Stop further execution
    //     }

    //     // Validate mobile number
    //     if (!/^(03\d{9}|923\d{9})$/.test(formData.mobileNumber)) {
    //         alert("Invalid mobile number format.");
    //         return; // Stop further execution
    //     }

    //     // Validate WhatsApp number
    //     if (!/^(03\d{9}|923\d{9})$/.test(formData.whatsappNumber)) {
    //         alert("Invalid WhatsApp number format.");
    //         return; // Stop further execution
    //     }


    //     onSubmit(formData);
    //     onClose();
    // };

    return (
       
        <motion.div
      className="modal-backdrop"
      onClick={handleBackdropClick}
      initial={{ opacity: 0 }} // Initial animation state
      animate={{ opacity: 1 }} // Animate to full opacity
      exit={{ opacity: 0 }} // Animate out to zero opacity
      transition={{ duration: 0.3 }} // Animation duration
    >
      <motion.div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        initial={{ y: -50, opacity: 0 }} // Initial animation state
        animate={{ y: 0, opacity: 1 }} // Animate to center and full opacity
        exit={{ y: -50, opacity: 0 }} // Animate out to top and zero opacity
        transition={{ duration: 0.3 }} // Animation duration
      >
        {/* Close Icon */}
        <span onClick={onClose} className="whatsApp-close-icon">
          <i className="ri-close-circle-fill" />
        </span>

        {/* Form Header */}
        <h3 className="header-text">Order On WhatsApp</h3>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          {/* Full Name */}
          <label> Full Name </label>
          <div className="whatsApp-form-wrapper">
            <i className="ri-user-3-line"></i>
            <input
              type="text"
              name="name"
              placeholder="Ali raza"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          {/* Email Address */}
          <label> Email Address (Optional) </label>
          <div className="whatsApp-form-wrapper">
            <i className="ri-mail-line"></i>
            <input
              type="email"
              name="email"
              placeholder="example123@gmail.com"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          {/* Mobile Number */}
          <label> Mobile Number </label>
          <div className="whatsApp-form-wrapper">
            <i className="ri-smartphone-line"></i>
            <input
              type="tel"
              name="mobileNumber"
              placeholder="0309xxxxxx or 923xxxxxxxxx"
              value={formData.mobileNumber}
              onChange={handleChange}
              required
            />
          </div>

          {/* WhatsApp Number */}
          <label> WhatsApp Number </label>
          <div className="whatsApp-form-wrapper">
            <i className="ri-whatsapp-line"></i>
            <input
              type="tel"
              name="whatsappNumber"
              placeholder="0309xxxxxx or 923xxxxxxxxx"
              value={formData.whatsappNumber}
              onChange={handleChange}
              required
            />
          </div>

          {/* Quantity */}
          <label> Quantity </label>
          <div className="whatsApp-form-wrapper">
            <i className="ri-hashtag"></i>
            <input
              type="number"
              name="productQuantity"
              placeholder="1"
              value={formData.productQuantity}
              onChange={handleChange}
              required
            />
          </div>

          {/* City and Province */}
          <div className="whatsApp-city-province">
            <div className="whatsApp-form-wrapper">
              <label> City </label>
              <i className="ri-map-2-line" />
              <input
                type="text"
                name="city"
                placeholder="Lahore"
                value={formData.city}
                onChange={handleChange}
                required
              />
            </div>
            <div className="whatsApp-form-wrapper">
              <label> Province </label>
              <i className="ri-building-line" />
              <input
                type="text"
                name="province"
                placeholder="Punjab"
                value={formData.province}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Shipping Address */}
          <label> Shipping Address </label>
          <div className="whatsApp-form-wrapper">
            <i className="ri-home-heart-line"></i>
            <input
              type="text"
              name="address"
              placeholder="House No 45, Street 10, Bahria Town Phase 4, Lahore, Punjab"
              value={formData.address}
              onChange={handleChange}
              required
            />
          </div>

          {/* Submit Button */}
          <motion.button 
          whileHover={{ scale: 1.05 }} // Hover effect
          whileTap={{ scale: 0.95 }} // Tap effect
          type="submit">
            Order on WhatsApp
        </motion.button>
        </form>
      </motion.div>
    </motion.div>
    );
}

export default WhatsAppOrderForm;









// // WhatsAppOrderForm.js
// import React, { useState } from 'react';
// import './WhatsAppOrderForm.css'

// function WhatsAppOrderForm({ onSubmit, onClose  }) {
//     const [formData, setFormData] = useState({
//         name: '',
//         email: '',
//         mobileNumber: '',
//         whatsappNumber: '',
//         productQuantity: 1,
//         address: ''
//     });

//     const [errors, setErrors] = useState({});

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         if (name === "productQuantity") {
//             const re = /^[1-9]\d*$/;  
//             if (value === '' || re.test(value)) {
//                 setFormData({ ...formData, [name]: value });
//             }
//         } else {
//             setFormData({ ...formData, [name]: value });
//         }
//         if (errors[name]) {
//             setErrors({ ...errors, [name]: null });
//         }
//     };

    

//     const handleSubmit = () => {
//         // let hasError = false;
//         // let newErrors = {};

//         // if (!formData.name) {
//         //     hasError = true;
//         //     newErrors.name = "Full Name is required.";
//         // }
//         // if (!formData.mobileNumber) {
//         //     hasError = true;
//         //     newErrors.mobileNumber = "Mobile number is required.";
//         // }
//         // if (!formData.whatsappNumber) {
//         //     hasError = true;
//         //     newErrors.whatsappNumber = "WhatsApp Number is required.";
//         // }
//         // if (!formData.address) {
//         //     hasError = true;
//         //     newErrors.address = "Address is required.";
//         // }

//         // if (hasError) {
//         //     setErrors(newErrors);
//         //     return; 
//         // }

//         onSubmit(formData);
//         onClose();
//     };

//     return (
//         <div className="modal-backdrop">
//             <div className="modal-content">
//                <span onClick={onClose} 
//                       className='whatsApp-close-icon'>
//                     <i class="ri-close-circle-fill" />
//                </span>

//                <form onSubmit={handleSubmit}>
                
//                 <label> Full Name </label>
//                 <div className='whatsApp-form-wrapper'>
//                 <i class="ri-user-3-line"></i>
//                   <input type="text" 
//                   name="name" 
//                   placeholder="Ali raza" 
//                   value={formData.name} 
//                   onChange={handleChange} 
//                   required />
//                   {/* {errors.name && <p style={{ color: 'red' }}>{errors.name}</p>} */}
//                 </div>

//                 <label> Email Address (Optional) </label>
//                 <div className='whatsApp-form-wrapper'>
//                   <i class="ri-mail-line"></i>
//                   <input type="email" 
//                   name="email" 
//                   placeholder="ali123@gmail.com" 
//                   value={formData.email} 
//                   onChange={handleChange} />
//                 </div>
                
//                 <label> Mobile Number </label>
//                 <div className='whatsApp-form-wrapper'>
//                   <i class="ri-smartphone-line"></i>
//                   <input type="tel" 
//                   name="mobileNumber" 
//                   placeholder='0309xxxxxx or 923xxxxxxxxx'  
//                   value={formData.mobileNumber} 
//                   onChange={handleChange} 
//                   required
//                   />
//                   {/* {errors.mobileNumber && <p style={{ color: 'red' }}>{errors.mobileNumber}</p>} */}
//                 </div>

//                 <label> WhatsApp Number </label>
//                 <div className='whatsApp-form-wrapper'>
//                   <i class="ri-whatsapp-line"></i>
//                   <input type="tel" 
//                   name="whatsappNumber" 
//                   placeholder='0309xxxxxx or 923xxxxxxxxx'   
//                   value={formData.whatsappNumber} 
//                   onChange={handleChange} 
//                   required
//                   />
//                   {/* {errors.whatsappNumber && <p style={{ color: 'red' }}>{errors.whatsappNumber}</p>} */}
//                 </div>

//                 <label> Quantity </label>
//                 <div className='whatsApp-form-wrapper'>
//                   <i class="ri-hashtag"></i>
//                   <input type="number" 
//                   name="productQuantity" 
//                   placeholder="1" 
//                   value={formData.productQuantity} 
//                   onChange={handleChange} 
//                   required
//                   />
//                 </div>

//                 <label> Shipping Address </label>
//                 <div className='whatsApp-form-wrapper'>
//                   <i class="ri-home-heart-line"></i>
//                   <input type="text" 
//                   name="address" 
//                   placeholder='House No 45, Street 10, Bahria Town Phase 4, Lahore, Punjab' 
//                   value={formData.address} 
//                   onChange={handleChange} 
//                   required/>
//                   {/* {errors.address && <p style={{ color: 'red' }}>{errors.address}</p>} */}
//                 </div>

//                 <button type="submit" >Order on WhatsApp</button>
//             </form>
//             </div>
//         </div>
//     );
// }

// export default WhatsAppOrderForm;
